// extracted by mini-css-extract-plugin
module.exports = {"container":"loader-inline_container__uhrwP","spin":"loader-inline_spin__auF_r","center":"loader-inline_center__0myH_"};